"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isRTL = function isRTL(props) {
  return false;
};
var reverseTransform = "scale(-1, 1)";

var SvgGlobe = function SvgGlobe(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return _react2.default.createElement(
    "svg",
    Object.assign({
      viewBox: "0 0 512 512",
      width: "1em",
      height: "1em",
      transform: isRTL(props) ? reverseTransform : null,
      ref: svgRef
    }, props),
    _react2.default.createElement("path", { d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm179.698 160h-84.125c-7.333-37.407-19.309-72.323-35.338-102.801C369.502 81.947 412.301 120.325 435.698 168zm16.318 128h-93.713c2.191-25.905 2.339-52.521-.017-80h93.73c5.309 26.293 5.317 53.669 0 80zm-250.08 0c-2.561-26.498-2.588-53.143-.041-80h108.21c2.545 26.832 2.522 53.475-.041 80H201.936zm100.544 48c-9.351 42.053-25.298 79.912-46.48 109.243-21.183-29.332-37.129-67.19-46.48-109.243h92.96zM59.984 216h93.73c-2.201 25.679-2.361 52.28-.017 80H59.984c-5.309-26.292-5.317-53.669 0-80zm149.41-48c9.275-41.974 25.172-79.655 46.606-109.277 21.434 29.622 37.332 67.304 46.606 109.277h-93.212zm-13.63-102.801C179.736 95.677 167.759 130.593 160.427 168H76.302c23.378-47.636 66.155-86.04 119.462-102.801zM76.302 344h84.043c7.301 37.472 19.247 72.317 35.308 102.766C142.008 429.864 99.48 391.227 76.302 344zm240.045 102.766c16.061-30.449 28.007-65.294 35.308-102.766h84.043c-23.217 47.307-65.791 85.891-119.351 102.766z" })
  );
};

var ForwardRef = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(SvgGlobe, Object.assign({ svgRef: ref }, props));
});
exports.default = ForwardRef;